import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../i18n';
import { monoFont } from '../theme.js';

const VARIANTS = {
  dark: { active: '#fff', inactive: 'rgba(255,255,255,0.5)', activeBg: 'rgba(255,255,255,0.15)' },
  light: { active: '#122019', inactive: '#9CA3AF', activeBg: '#F2F5F2' },
};

export default function LanguageSwitcher({ variant = 'dark', sx }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith('en') ? 'en' : 'fr';
  const c = VARIANTS[variant] || VARIANTS.dark;

  return (
    <Box role="group" aria-label="Langue / Language" sx={{ display: 'flex', alignItems: 'center', gap: 0.25, ...sx }}>
      {['fr', 'en'].map((lang) => (
        <ButtonBase
          key={lang}
          onClick={() => setLanguage(lang)}
          aria-pressed={current === lang}
          sx={{
            px: 0.75,
            py: 0.25,
            borderRadius: 1,
            fontFamily: monoFont,
            fontSize: 11.5,
            fontWeight: 500,
            letterSpacing: '0.05em',
            color: current === lang ? c.active : c.inactive,
            bgcolor: current === lang ? c.activeBg : 'transparent',
            '&:hover': { color: c.active },
          }}
        >
          {lang.toUpperCase()}
        </ButtonBase>
      ))}
    </Box>
  );
}
